import { render, staticRenderFns } from "./supervisor.vue?vue&type=template&id=2b96cf62&"
import script from "./supervisor.vue?vue&type=script&lang=js&"
export * from "./supervisor.vue?vue&type=script&lang=js&"
import style0 from "./supervisor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports